import { useEffect, useState } from "react";
import { LiaSearchPlusSolid } from "react-icons/lia";
import { MdClose, MdEdit, MdModeEdit } from "react-icons/md";
import { aging } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import ConfirmDeleteModal from "../../common/DeleteModel";
import ErrorModal from "../../common/CustomModel";
import AgingForm from "./AgingForm";
import { HiOutlinePlus } from "react-icons/hi";
import Button from "../../common/Button";
import {
  IoIosSave,
  IoMdArrowDropdown,
  IoMdArrowDropright,
} from "react-icons/io";
import { AiOutlineCheck } from "react-icons/ai";
import { IoCloseSharp } from "react-icons/io5";

const Aging = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorSubMessage, setErrorSubMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isAgingData, setIsAgingData] = useState([]);
  const [isQcDoneData, setIsQcDoneData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const pageSize = 10;
  const [formData, setFormData] = useState({
    aging_No: 0,
    aging_Date: "",
    start_Gas_Reading: "",
    end_Gas_Reading: "",
    total_Consumption: "",
    temperature: "",
    shift: "",
    in_Time: "",
    out_Time: "",
    total_Time: "",
    created_By: 1,
    agingDetails: [
      {
        aging_No: 0,
        seq_No: 0,
        batch_Id: "",
        cut_Length: "",
        quantity: "",
        hardness: "",
        remark: "",
        die_Id: "",
        casting_No: "",
        po_No: "",
      },
    ],
  });
  const [selectedQcData, setSelectedQcData] = useState(null);
  const [isActiveTab, setIsActiveTab] = useState("qc-done");
  const [adding, setAdding] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedSeqs, setSelectedSeqs] = useState([]);
  const [expandedRows, setExpandedRows] = useState(new Set());
  const [editingRows, setEditingRows] = useState(new Set());
  const [draftRows, setDraftRows] = useState({});

  const cancelEdit = (id) => {
    setEditingRows((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
    setDraftRows((prev) => {
      const next = { ...prev };
      delete next[id];
      return next;
    });
  };
  const parseTimeToMinutes = (t) => {
    if (!t) return null;
    const [h = 0, m = 0] = String(t).split(":").map(Number);
    return h * 60 + m;
  };

  const parseDurationToMinutes = (v) => {
    if (v === "" || v == null) return null;
    const s = String(v).trim();

    if (s.includes(":")) {
      const [h = 0, m = 0] = s.split(":").map(Number);
      return h * 60 + m;
    }
    const n = Number(s);
    if (Number.isFinite(n)) return Math.round(n * 60);

    return null;
  };

  const minutesToHHMM = (mins) => {
    const m = ((mins % 1440) + 1440) % 1440;
    const h = Math.floor(m / 60);
    const mm = m % 60;
    return String(h).padStart(2, "0") + ":" + String(mm).padStart(2, "0");
  };
  const changeDraft = (id, field, value) => {
    setDraftRows((prev) => {
      const base = prev[id] ?? {};
      const next = { ...base, [field]: value };

      if (field === "start_Gas_Reading" || field === "end_Gas_Reading") {
        const s = Number(next.start_Gas_Reading || 0);
        const e = Number(next.end_Gas_Reading || 0);
        next.total_Consumption = e - s;
      }
      const startMins = parseTimeToMinutes(next.in_Time);
      const durMins = parseDurationToMinutes(next.out_Time);

      if (startMins != null && durMins != null) {
        next.total_Time = minutesToHHMM(startMins + durMins);
      } else {
        next.total_Time = "";
      }
      return { ...prev, [id]: next };
    });
  };

  const toggleExpand = (id) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const fetchAgingData = async () => {
    setLoading(true);
    try {
      const res = await aging.getAllAging(currentPage, pageSize);

      const normalized = (res.data || []).map((r) => ({
        ...r,
        agingDetails: r.details ?? [],
      }));

      setIsAgingData(normalized);
      setFilteredData(normalized);
      setTotalRecords(
        res.totalCount || res.totalRecords || normalized.length || 0
      );
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  const fetchQcDoneData = async () => {
    setLoading(true);
    try {
      const res = await aging.getAllQcDone(currentPage, pageSize);
      setIsQcDoneData(res.data || []);
      setFilteredData(res.data || []);
      setTotalRecords(res.totalCount || res.data?.length || 0);
    } catch (error) {
      notify("Error fetching location data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAgingData();
    fetchQcDoneData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isAgingData);
    } else {
      const filtered = isAgingData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isAgingData]);

  const handleConfirmDelete = async () => {
    try {
      await aging.delete(selectedId);
      notify("Deleted successfully", "success");
      fetchAgingData();
    } catch (error) {
      notify("Failed to delete record", "error");
    }
    setIsDeleteModalOpen(false);
    setSelectedId(null);
  };
  const toDecimal = (v) => {
    if (v === null || v === undefined) return null;
    const s = String(v).trim();
    if (s === "") return null;
    const n = parseFloat(s.replace(/,/g, ""));
    return Number.isFinite(n) ? n : null;
  };
  const pickDetails = (src) => {
    const raw = src?.agingDetails ?? src?.details ?? [];
    if (!Array.isArray(raw) || raw.length === 0) return null;

    return raw.map((d) => ({
      seq_No: d.seq_No ?? 0,
      aging_No: d.aging_No ?? src.aging_No ?? 0,
      batch_Id: d.batch_Id ?? "",
      casting_No: d.casting_No ?? "",
      die_Id: d.die_Id ?? null,
      dieNumber: d.dieNumber ?? "",
      cut_Length: toDecimal(d.cut_Length) ?? 0,
      quantity: toDecimal(d.quantity) ?? 0,
      hardness: toDecimal(d.hardness) ?? 0,
      remark: d.remark ?? "",
      po_No: d.po_No ?? null,
      approved_Pcs: d.approved_Pcs ?? 0,
    }));
  };
  const buildPayload = (src) => {
    const start = toDecimal(src.start_Gas_Reading) ?? 0;
    const end = toDecimal(src.end_Gas_Reading) ?? 0;

    const payload = {
      aging_No: src.aging_No ? Number(src.aging_No) : 0,
      aging_Date: src.aging_Date || null,
      start_Gas_Reading: start,
      end_Gas_Reading: end,
      total_Consumption: toDecimal(src.total_Consumption) ?? end - start,
      temperature: toDecimal(src.temperature) ?? 0,
      shift: src.shift ?? "",
      in_Time: src.in_Time ?? "",
      out_Time: src.out_Time ?? "",
      total_Time: src.total_Time ?? "",
      created_By: src.created_By ?? 1,
    };

    const details = pickDetails(src);
    if (details) payload.agingDetails = details;

    return payload;
  };
  const saveAging = async (source) => {
    const payload = buildPayload(source);
    const res = await aging.saveOrUpdate(payload);

    const newNo = res?.data?.aging_No ?? res?.aging_No ?? payload.aging_No ?? 0;
    payload.aging_No = newNo;
    notify(
      newNo > 0 && (source.aging_No ?? 0) > 0 ? "Updated" : "Saved",
      "success"
    );
    return payload;
  };
  const normalizeAgingForRow = (api) => {
    const details = (api.agingDetails ?? api.details ?? []).map((d) => ({
      seq_No: d.seq_No ?? 0,
      aging_No: d.aging_No ?? api.aging_No ?? 0,
      batch_Id: d.batch_Id ?? "",
      casting_No: d.casting_No ?? "",
      die_Id: d.die_Id ?? null,
      dieNumber: d.dieNumber ?? "",
      cut_Length: toDecimal(d.cut_Length) ?? "",
      quantity: toDecimal(d.quantity) ?? "",
      hardness: toDecimal(d.hardness) ?? "",
      remark: d.remark ?? "",
      po_No: d.po_No ?? "",
      approved_Pcs: d.approved_Pcs ?? 0,
    }));

    return {
      ...api,
      aging_Date: (api.aging_Date || "").split("T")[0] || "",
      start_Gas_Reading: api.start_Gas_Reading ?? "",
      end_Gas_Reading: api.end_Gas_Reading ?? "",
      total_Consumption: api.total_Consumption ?? "",
      temperature: api.temperature ?? "",
      shift: api.shift ?? "",
      in_Time: api.in_Time ?? "",
      out_Time: api.out_Time ?? "",
      total_Time: api.total_Time ?? "",
      status: api.status === true ? "Done" : api.status ?? "",
      details,
      agingDetails: details,
    };
  };
  const changeDetailQty = (parentId, detailIndex, value) => {
    setDraftRows((prev) => {
      const base =
        prev[parentId] ??
        isAgingData.find((r) => r.aging_No === parentId) ??
        {};
      const details = [...(base.agingDetails ?? base.details ?? [])];
      const d = { ...(details[detailIndex] ?? {}) };
      d.quantity = value;
      details[detailIndex] = d;

      const next = { ...base, agingDetails: details, details };
      return { ...prev, [parentId]: next };
    });
  };
  const ensureQtyMatchesApproved = (source) => {
    const orig = source?.agingDetails ?? source?.details ?? [];
    if (!Array.isArray(orig) || !orig.length) {
      return { ok: false, fixed: false, fixedSource: source };
    }
    let changed = false;
    const details = orig.map((d) => {
      const ap = Number(d.approved_Pcs ?? 0);
      const q = Number(d.quantity ?? 0);
      if (!Number.isFinite(ap)) return { ...d };
      if (q !== ap) {
        changed = true;
        return { ...d, quantity: ap };
      }
      return { ...d };
    });

    const fixedSource = { ...source, agingDetails: details, details };
    const ok = details.every(
      (d) => Number(d.quantity ?? 0) === Number(d.approved_Pcs ?? 0)
    );
    return { ok, fixed: changed, fixedSource };
  };

  const handleEdit = async (id) => {
    setLoading(true);
    try {
      const res = await aging.getById(id);
      const entity = res?.data ?? res;
      const record = Array.isArray(entity) ? entity[0] : entity;
      const normalized = normalizeAgingForRow(record || {});
      setDraftRows((prev) => ({ ...prev, [id]: normalized }));
      setEditingRows((prev) => new Set(prev).add(id));
    } catch (e) {
      notify(e?.response?.data?.message || "Failed to load record", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleRowSave = async (id) => {
    const row = draftRows[id] ?? isAgingData.find((r) => r.aging_No === id);
    if (!row) return notify("Row not found.", "error");

    await saveAging({ ...row, fromGrid: true });
    setEditingRows((prev) => {
      const n = new Set(prev);
      n.delete(id);
      return n;
    });
    setDraftRows((prev) => {
      const n = { ...prev };
      delete n[id];
      return n;
    });
    fetchAgingData();
  };
  const handleSubmit = async () => {
    await saveAging(formData);
    setIsModelOpen(false);
    fetchAgingData();
    fetchQcDoneData();
  };

  const buildMarkDoneFromDetail = (detail, aging_No) => {
    if (!detail) return null;
    return {
      Aging_No: Number(aging_No ?? detail.aging_No ?? 0),
      Batch_Id: detail.batch_Id ?? "",
      Casting_No: detail.casting_No ?? "",
      Die_Id: detail.die_Id ?? null,
      Created_By: 1,
    };
  };

  const callMarkDone = async (payload) => {
    if (!payload || !payload.Aging_No || !payload.Batch_Id) {
      notify("Mark Done needs Aging No and Batch Id.", "warning");
      return;
    }
    try {
      await aging.MarkAgingDone(payload);
      notify("Marked as Done", "success");
      fetchAgingData();
      fetchQcDoneData();
    } catch (e) {
      console.error("MarkDone error:", e?.response?.data || e);
      notify(
        e?.response?.data?.message || "Failed to mark production as done",
        "error"
      );
    }
  };
  const toNum = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

  const validateQtyVsApproved = (source) => {
    const details = source?.agingDetails ?? source?.details ?? [];
    const mismatches = [];

    for (let i = 0; i < details.length; i++) {
      const d = details[i];
      const qty = toNum(d.quantity);
      const ap = toNum(d.approved_Pcs);

      if (qty !== ap) {
        mismatches.push({
          index: i,
          batch_Id: d.batch_Id,
          die: d.dieNumber ?? d.die_Id ?? "",
          qty,
          ap,
        });
      }
    }
    return mismatches; // [] means OK
  };

  const saveThenMarkDoneFromSource = async (
    source,
    { closeForm = false } = {}
  ) => {
    const details = source?.agingDetails ?? source?.details ?? [];
    if (!details.length) {
      notify("Add at least one detail before Mark Done.", "warning");
      return;
    }

    // 🔒 ensure Qty == Approved_Pcs; auto-fix if needed
    const { ok, fixed, fixedSource } = ensureQtyMatchesApproved(source);
    const toSave = fixed ? fixedSource : source;

    if (fixed) {
      notify("Qty adjusted to match Approved Pcs. Saving…", "info");
    }

    const saved = await saveAging(toSave);
    const finalAgingNo = saved.aging_No;
    const first = {
      ...((toSave.agingDetails ?? toSave.details ?? [])[0] || {}),
      aging_No: finalAgingNo,
    };

    // After save, re-check OK (it should be)
    const { ok: okAfter } = ensureQtyMatchesApproved(saved);
    if (!okAfter) {
      notify(
        "Qty must equal Approved Pcs for all details before Mark Done.",
        "error"
      );
      return;
    }

    const mdPayload = buildMarkDoneFromDetail(first, finalAgingNo);
    await callMarkDone(mdPayload);

    if (closeForm) setIsModelOpen(false);
    fetchQcDoneData();
  };
  const handleMarkDoneRow = async (row) => {
    // prefer latest draft if the row is being edited
    const source = draftRows[row.aging_No] ? draftRows[row.aging_No] : row;

    // 🔒 Strict check FIRST — do not save or call MarkDone if invalid
    const mismatches = validateQtyVsApproved(source);
    if (mismatches.length) {
      // Optional: show first mismatch detail for clarity
      const m = mismatches[0];
      notify(
        `Qty must equal Approved Pcs for all details. First mismatch at row ${
          m.index + 1
        }: Qty=${m.qty}, Approved=${m.ap}`,
        "error"
      );
      return; // ⛔ STOP here
    }

    // ✅ All good: save, then MarkDone
    const saved = await saveAging(source);

    // (Re)validate using saved object just to be safe
    const recheck = validateQtyVsApproved(saved);
    if (recheck.length) {
      notify(
        "Validation failed after save. Please re-check quantities.",
        "error"
      );
      return;
    }

    const finalAgingNo = saved.aging_No;
    const firstDetail = (saved.agingDetails ?? saved.details ?? [])[0];
    const mdPayload = buildMarkDoneFromDetail(firstDetail, finalAgingNo);
    await callMarkDone(mdPayload);
  };

  // const handleMarkDoneRow = async (row) => {
  //   const source = draftRows[row.aging_No] ? draftRows[row.aging_No] : row;
  //   await saveThenMarkDoneFromSource(source, { closeForm: false });
  // };

  const handleFieldChange = (field, value) => {
    setSelectedQcData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleAdd = async () => {
    if (selectedSeqs.length === 0) {
      notify("Please select at least one QC-Done row.", "warning");
      return;
    }

    setAdding(true);
    try {
      const payload = selectedSeqs.map(Number);
      const res = await aging.AddToAging(payload);
      const items = Array.isArray(res) ? res : res?.data || [];

      const rows = items.map((x) => ({
        batch_Id: x.batch_Id ?? "",
        die_Id: x.die_Id ?? "",
        dieNumber: x.dieNumber ?? "",
        casting_No: x.casting_No ?? "",
        cut_Length: x.cut_Length ?? "",
        po_No: String(x.order_No ?? x.so_No ?? ""),
        approved_Pcs: Number(x.approved_Pcs ?? 0),
        quantity: "",
        hardness: "",
        remark: "",
      }));
      setFormData((prev) => {
        const base =
          prev?.aging_No != null
            ? prev
            : {
                aging_No: 0,
                aging_Date: "",
                start_Gas_Reading: "",
                end_Gas_Reading: "",
                total_Consumption: "",
                temperature: "",
                shift: "",
                in_Time: "",
                out_Time: "",
                total_Time: "",
                created_By: 1,
                agingDetails: [],
              };
        return { ...base, agingDetails: rows };
      });

      setSelectedQcData((prev) => ({ ...(prev || {}), agingDetails: rows }));
      setIsActiveTab("aging");
      setIsModelOpen(true);
      setIsEditing(false);
    } catch (e) {
      notify(
        e?.response?.data?.message || e?.message || "Failed to Add to Aging",
        "error"
      );
    } finally {
      setAdding(false);
    }
  };

  const columns = [
    {
      key: "select",
      label: (
        <input
          type="checkbox"
          checked={
            isQcDoneData.length > 0 &&
            isQcDoneData.every((r) => selectedSeqs.includes(r.seq_No))
          }
          onChange={(e) => {
            if (e.target.checked) {
              const pageIds = isQcDoneData.map((r) => r.seq_No);
              setSelectedSeqs((prev) =>
                Array.from(new Set([...prev, ...pageIds]))
              );
            } else {
              const pageSet = new Set(isQcDoneData.map((r) => r.seq_No));
              setSelectedSeqs((prev) => prev.filter((id) => !pageSet.has(id)));
            }
          }}
        />
      ),
      render: (_v, row) => (
        <input
          type="checkbox"
          checked={selectedSeqs.includes(row.seq_No)}
          onChange={(e) => {
            const id = Number(row.seq_No);
            setSelectedSeqs((prev) =>
              e.target.checked ? [...prev, id] : prev.filter((x) => x !== id)
            );
          }}
        />
      ),
    },
    { key: "order_No", label: "ORDER NO" },
    { key: "batch_Id", label: "BATCH NO" },
    { key: "dieNumber", label: "DIE NO" },
    { key: "approved_Pcs", label: "Approved Pcs" },
    { key: "packing_Instructions", label: "PACKING INSTRUCTIONS" },
    { key: "general_Notes", label: "GENERAL NOTES" },
  ];

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5  mt-10 ">
        <div className="flex flex-wrap justify-between items-center gap-4 mb-4">
          <div className="relative w-full sm:w-1/2 lg:w-1/3">
            <input
              type="text"
              className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button
              icon={LiaSearchPlusSolid}
              iconColor="text-primary"
              iconSize="w-5 h-5"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
            ></Button>
            {searchQuery && (
              <Button
                icon={MdClose}
                iconSize="w-5 h-5"
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
              >
                <MdClose />
              </Button>
            )}
          </div>
          {isActiveTab === "qc-done" && (
            <Button
              text={
                adding
                  ? "Adding..."
                  : `Add Aging${
                      selectedSeqs.length ? ` (${selectedSeqs.length})` : ""
                    }`
              }
              className="text-black text-md font-semibold bg-orange rounded-md p-2 disabled:opacity-60"
              onClick={handleAdd}
              icon={HiOutlinePlus}
              iconColor="text-black"
              iconSpacing="pr-2"
              disabled={adding || selectedSeqs.length === 0}
            />
          )}
        </div>
        <div className="flex border-b border-gray-200 mb-4">
          <div
            onClick={() => setIsActiveTab("qc-done")}
            className={`mr-8 pb-2 cursor-pointer relative font-semibold ${
              isActiveTab === "qc-done"
                ? "text-primary border-b-2 border-primary"
                : "text-secondary"
            }`}
          >
            QC Done
          </div>
          <div
            onClick={() => setIsActiveTab("aging")}
            className={`pb-2 cursor-pointer relative font-semibold ${
              isActiveTab === "aging"
                ? "text-primary border-b-2 border-primary"
                : "text-secondary"
            }`}
          >
            Aging Entry
          </div>
        </div>

        {isActiveTab === "qc-done" && (
          <Table columns={columns} data={isQcDoneData} showActions={false} />
        )}
        {isActiveTab === "aging" &&
          (loading ? (
            <Loader />
          ) : (
            <div className="overflow-x-auto border border-slate-300 rounded-md">
              <table className=" w-full text-[13px]">
                <colgroup>
                  <col className="w-8" />
                  <col className="w-10" />
                  <col className="w-20" />
                  <col className="w-40" />
                  <col className="w-20" />
                  <col className="w-20" />
                  <col className="w-20" />
                  <col className="w-20" />
                  <col className="w-20" />
                  <col className="w-20" />
                  <col className="w-20" />
                  <col className="w-20" />
                  <col className="w-20" />
                  <col className="w-20" />
                </colgroup>

                <thead className="bg-slate-50 text-slate-700 sticky top-0 z-10">
                  <tr className="text-center text-[12px] font-medium">
                    <th className="border border-slate-200 p-1"></th>
                    <th className="border border-slate-200 p-1"></th>
                    <th className="border border-slate-200 p-1">AGING NO</th>
                    <th className="border border-slate-200 p-1">AGING DATE</th>
                    <th className="border border-slate-200 p-1">
                      START GAS READING
                    </th>
                    <th className="border border-slate-200 p-1">
                      END GAS READING
                    </th>
                    <th className="border border-slate-200 p-1">
                      TOTAL CONSUMPTION
                    </th>
                    <th className="border border-slate-200 p-1">TEMPERATURE</th>
                    <th className="border border-slate-200 p-1">SHIFT</th>
                    <th className="border border-slate-200 p-1">IN TIME</th>
                    <th className="border border-slate-200 p-1">OUT TIME</th>
                    <th className="border border-slate-200 p-1">TOTAL TIME</th>
                    <th className="border border-slate-200 p-1">STATUS</th>
                    <th className="border border-slate-200 p-1">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {isAgingData.map((row, index) => {
                    const id =
                      row.aging_No ?? `${row.so_No}-${row.batch_Id}-${index}`;
                    const isOpen = expandedRows.has(id);
                    const isEditingRow = editingRows.has(id);
                    const d = isEditingRow ? draftRows[id] ?? row : row;
                    return (
                      <>
                        <tr className="hover:bg-slate-50">
                          <td className="border p-1 text-center">
                            <button onClick={() => toggleExpand(id)}>
                              {isOpen ? (
                                <IoMdArrowDropdown />
                              ) : (
                                <IoMdArrowDropright />
                              )}
                            </button>
                          </td>
                          <td className="border border-slate-200 p-1 text-center align-middle">
                            <input
                              type="checkbox"
                              checked={
                                isQcDoneData.length > 0 &&
                                selectedIds.length ===
                                  isQcDoneData
                                    .filter((i) => i?.seq_No)
                                    .map((i) => i.seq_No).length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  const allIds = isQcDoneData
                                    .filter((i) => i?.seq_No)
                                    .map((i) => i.seq_No);
                                  setSelectedIds(allIds);
                                } else {
                                  setSelectedIds([]);
                                }
                              }}
                            />
                          </td>
                          <td className="border border-slate-200 p-1">
                            <input
                              value={row.aging_No}
                              disabled
                              className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                            />
                          </td>
                          <td className="border p-1">
                            <input
                              value={row.aging_Date}
                              disabled
                              className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                            />
                          </td>
                          <td className="border p-1">
                            {isEditingRow ? (
                              <input
                                className="w-full border rounded px-2 py-1 text-right"
                                value={d.start_Gas_Reading ?? ""}
                                onChange={(e) =>
                                  changeDraft(
                                    id,
                                    "start_Gas_Reading",
                                    e.target.value
                                  )
                                }
                              />
                            ) : (
                              <span className="block text-right">
                                {row.start_Gas_Reading}
                              </span>
                            )}
                          </td>

                          <td className="border p-1">
                            {isEditingRow ? (
                              <input
                                className="w-full border rounded px-2 py-1 text-right"
                                value={d.end_Gas_Reading ?? ""}
                                onChange={(e) =>
                                  changeDraft(
                                    id,
                                    "end_Gas_Reading",
                                    e.target.value
                                  )
                                }
                              />
                            ) : (
                              <span className="block text-right">
                                {row.end_Gas_Reading}
                              </span>
                            )}
                          </td>

                          <td className="border p-1">
                            {isEditingRow ? (
                              <input
                                className="w-full border rounded px-2 py-1 text-right"
                                value={d.total_Consumption ?? ""}
                                onChange={(e) =>
                                  changeDraft(
                                    id,
                                    "total_Consumption",
                                    e.target.value
                                  )
                                }
                              />
                            ) : (
                              <span className="block text-right">
                                {row.total_Consumption}
                              </span>
                            )}
                          </td>

                          <td className="border p-1">
                            {isEditingRow ? (
                              <input
                                className="w-full border rounded px-2 py-1 text-right"
                                value={d.temperature ?? ""}
                                onChange={(e) =>
                                  changeDraft(id, "temperature", e.target.value)
                                }
                              />
                            ) : (
                              <span className="block text-right">
                                {row.temperature}
                              </span>
                            )}
                          </td>
                          <td className="border p-1">
                            {isEditingRow ? (
                              <input
                                className="w-full border rounded px-2 py-1 text-right"
                                value={d.shift ?? ""}
                                onChange={(e) =>
                                  changeDraft(id, "shift", e.target.value)
                                }
                              />
                            ) : (
                              <span className="block text-right">
                                {row.shift}
                              </span>
                            )}
                          </td>

                          <td className="border p-1">
                            {isEditingRow ? (
                              <input
                                type="time"
                                className="w-full border rounded px-2 py-1 text-right"
                                value={d.in_Time ?? ""}
                                onChange={(e) =>
                                  changeDraft(id, "in_Time", e.target.value)
                                }
                              />
                            ) : (
                              <span className="block text-right">
                                {row.in_Time}
                              </span>
                            )}
                          </td>
                          <td className="border p-1">
                            {isEditingRow ? (
                              <input
                                className="w-full border rounded px-2 py-1 text-right"
                                value={d.out_Time ?? ""}
                                onChange={(e) =>
                                  changeDraft(id, "out_Time", e.target.value)
                                }
                              />
                            ) : (
                              <span className="block text-right">
                                {row.out_Time}
                              </span>
                            )}
                          </td>
                          <td className="border p-1">
                            {isEditingRow ? (
                              <input
                                type="time"
                                className="w-full border rounded px-2 py-1 text-right"
                                value={d.total_Time ?? ""}
                                onChange={(e) =>
                                  changeDraft(id, "total_Time", e.target.value)
                                }
                              />
                            ) : (
                              <span className="block text-right">
                                {row.total_Time}
                              </span>
                            )}
                          </td>
                          <td className="border border-slate-200 p-1">
                            <input
                              step="0.001"
                              value={row.status}
                              disabled
                              className="w-full bg-slate-100 text-slate-700 rounded px-2 py-1 outline-none"
                              placeholder="0.000"
                            />
                          </td>

                          <td className="border p-1 text-center">
                            {!isEditingRow ? (
                              <div className="inline-flex gap-2">
                                <button
                                  className="px-2 py-1 text-primary"
                                  onClick={() => handleEdit(row.aging_No)}
                                >
                                  <MdEdit />
                                </button>
                              </div>
                            ) : (
                              <div className="inline-flex gap-2">
                                <button
                                  className="px-2 py-1 text-green-700"
                                  onClick={() => handleRowSave(d.aging_No)}
                                >
                                  <IoIosSave />
                                </button>

                                <button
                                  className="px-2 py-1 text-slate-600"
                                  onClick={() => cancelEdit(id)}
                                >
                                  <IoCloseSharp />
                                </button>
                              </div>
                            )}
                            <button
                              type="button"
                              onClick={() => handleMarkDoneRow(row)}
                              className="px-2 py-1 rounded text-primary "
                              title="Mark Done"
                            >
                              <AiOutlineCheck />
                            </button>
                          </td>
                        </tr>
                        {expandedRows.has(row.aging_No) && (
                          <tr>
                            <td className="border p-0"></td>
                            <td className="border p-0" colSpan={15}>
                              <div className="p-3">
                                <table className="w-full text-[12px] border border-slate-200">
                                  <thead className="bg-slate-100">
                                    <tr>
                                      <th className="border p-1">Order No</th>
                                      <th className="border p-1">Batch</th>
                                      <th className="border p-1">Die</th>
                                      {/* <th className="border p-1">Casting</th> */}
                                      <th className="border p-1">Cut Length</th>
                                      <th className="border p-1">
                                        Approved Pcs
                                      </th>
                                      <th className="border p-1">Qty</th>
                                      <th className="border p-1">Hardness</th>
                                      <th className="border p-1">Remark</th>
                                      {/* <th className="border p-1">PO / SO</th> */}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {(row.details ?? []).length ? (
                                      row.details.map((detail, i) => {
                                        const parentId =
                                          row.aging_No ??
                                          `${row.so_No}-${row.batch_Id}-${index}`;
                                        const isEditingRow =
                                          editingRows.has(parentId);
                                        const editedParent =
                                          draftRows[parentId];
                                        const editedDetail =
                                          editedParent?.agingDetails?.[i] ??
                                          detail;

                                        return (
                                          <tr key={i}>
                                            <td className="border p-1">
                                              {detail.po_No}
                                            </td>
                                            <td className="border p-1">
                                              {detail.batch_Id}
                                            </td>
                                            <td className="border p-1">
                                              {detail.die_Id ??
                                                detail.dieNumber}
                                            </td>
                                            <td className="border p-1 text-right">
                                              {detail.cut_Length}
                                            </td>
                                            <td className="border p-1 text-right">
                                              {detail.approved_Pcs}
                                            </td>

                                            {/* Qty — ONLY editable when parent is edited */}
                                            <td className="border p-1 text-right">
                                              {isEditingRow ? (
                                                <input
                                                  className="w-full border rounded px-2 py-1 text-right"
                                                  value={
                                                    editedDetail.quantity ?? ""
                                                  }
                                                  onChange={(e) =>
                                                    changeDetailQty(
                                                      parentId,
                                                      i,
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              ) : (
                                                <span>{detail.quantity}</span>
                                              )}
                                            </td>

                                            {/* Others forced read-only even in edit mode */}
                                            <td className="border p-1 text-right">
                                              <span>{detail.hardness}</span>
                                            </td>
                                            <td className="border p-1">
                                              <span>{detail.remark}</span>
                                            </td>
                                          </tr>
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td
                                          className="border p-2 text-center"
                                          colSpan={9}
                                        >
                                          No details found.
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        )}
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ))}

        <div className="flex justify-center items-center mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize)}
            onPageChange={setCurrentPage}
          />
        </div>
      </div>

      {isModelOpen && formData && (
        <AgingForm
          data={selectedQcData}
          onChange={handleFieldChange}
          setFormData={setFormData}
          formData={formData}
          onSubmit={handleSubmit}
          onClose={() => {
            setIsModelOpen(false);
            setSelectedQcData(null);
          }}
          refreshList={fetchQcDoneData}
          refreshAgingList={fetchAgingData}
          onMarkDone={() =>
            saveThenMarkDoneFromSource(formData, { closeForm: true })
          }
        />
      )}

      <ConfirmDeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleConfirmDelete}
      />

      {errorModalOpen && (
        <ErrorModal
          message={errorMessage}
          subMessage={errorSubMessage}
          onClose={() => setErrorModalOpen(false)}
        />
      )}
    </>
  );
};

export default Aging;
